module.exports = __webpack_public_path__ + "static/media/depatu03.226c47b9.svg";